module.exports = KalturaPlayer.ui.preactHooks;